export const Image_Url = {
    TVSADMIN: '/img/tvs_logo.svg',
    TVSADMIN1: '/img/TVSADMIN1.jpeg',
    SEARCH:'/img/search.svg',
    EDIT:'/img/edit.svg',
    TVSLOGO:'/img/tvs_logo.svg',
    PROFILE:'/img/profile.svg',
    SHOP_IMG:'/img/shop.jpeg',
    VERIFICATON_ID:'/img/aadhaar-card.webp',
    TVSADMIN1: '/img/TVSADMIN1.jpeg',
    SEARCH:'/img/search.svg',
    EDIT:'/img/edit.svg',
    TVSLOGO:'/img/tvs_logo.svg',
    PGMLIST:'/img/PGM List.svg',
    REWARD:'/img/Reward Catalogue.svg',
    QUERY:'/img/Query.svg',
    FAQ:'/img/FAQ.svg',
    TRAINING:'/img/Training.svg',  
    CREATETRAINING:'/img/Create Training.svg',
    VIEWTRAINING:'/img/View Training.svg',
    NOTALLOWED:"/img/not-allowed.jpg",
    TRAINING_ICON:"/img/TrainingIcon.svg",
    SEND_INVITE_ICON:"/img/View Training.svg",
    LOGOUT:"/img/logout.png",
    PLUSICONS:"/img/plusimages.png",
    MINUSICONS:"/img/minuimages.png",
    CROSS:"/img/cross.svg",
    CROSSC:"/img/crossc.png",
    SETTING_ICON:"/img/settings.svg",
    CHANGE_PASSWORD_ICON:"/img/password-change.svg",
    REPORT:"/img/report.svg",
    NOTIFICATION:"/img/notification.svg",
    USERMANAGEMENT:"/img/usermanagement.svg",
    ROLE:"/img/role.svg",
    ROLEUSER:"/img/roleuser.svg",
    BANNER:"/img/banner.png",
    REFFERAL:"/img/referral.png",
    PRODUCTTRAINING:"/img/Product_training.svg",
    THUMBNAILS:"/img/thumbnail.png",
    PDF:"/img/pdf.png",
    DSR_ICON:"/img/dsr-icon.png",
    BEAT_MAP:"/img/BeatMap.png",
    INCENTIVE_MAPPING:"/img/IncentiveMapping.png",
    EXCEL_LOGO:"/img/Excel_icon.svg",
    PINCODE_MASTER_LIST_ICON:"/img/Pincodemaster.png",
    PLAN_VS_ACTUAL_ICON:"/img/planvsactual.png",
    DBT_CONFIGURATION:"/img/DBTConfiguration.png",
    MSR_ICON:"/img/MSR.png",
    PGM_LIST:"/img/pgmlist.png",
    RETAILER_LIST:"img/Retailerlist.png",
    DBT_INVOICE_SCAN_STATUS_ICON:"/img/dbt-invoice-scan.png",
    DELETE_ICONS:"/img/deleteicons.svg",
    VIEW_ICON:"/img/View Training.svg",
  }